import prepareOptions from '../../prepareOptions';

export default prepareOptions([
  {
    value: 'green',
    label: '4',
  },
  {
    value: 'yellow',
    label: '3',
  },
  {
    value: 'red',
    label: '2',
  },
]);
